<script>
export default {
  props: {
    title: String,
    titleT: String,
    colStyle: { type: String, default: '' },
    titleLevel: { type: String, default: '4' },
    classHeader: { type: String, default: '' },
    classBody: { type: String, default: '' },
    innerBlocClass: { type: String, default: '' },
    blocContentClass: { type: String, default: '' },
    color: { type: String, default: 'dark' },
    icon: { type: String },
    boxShadow: { type: Boolean, default: true },
  },

  computed: {
    titleComputed: function () {
      if (this.titleT) {
        return this.$t(String(this.titleT))
      }
      return this.title
    },

    hasHeader: function () {
      return this.$slots.header
    },
    titleClass() {
      if (!!this.titleComputed && this.titleLevel) {
        return `h` + this.titleLevel
      }

      return ''
    },
    boxShadowStyle() {
      return this.boxShadow ? { boxShadow: 'rgb(25 55 105 / 15%) 5px 5px 2px 1px' } : {}
    },
  },

  methods: {
    isHeader(level) {
      if (!this.$slots.header && parseInt(this.titleLevel) === level) {
        return this.titleT || this.title
      }
      return false
    },
  },
}
</script>
<template>
  <div :class="'bloc-col-md ' + (colStyle.length > 0 ? colStyle : '')">
    <div :class="'bloc ' + innerBlocClass" :style="boxShadowStyle">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div v-if="hasHeader" :class="'d-flex justify-content-between ' + titleClass">
            <slot name="header"></slot>
          </div>
          <h2 v-if="isHeader(2)" v-html="titleComputed" :class="'text-' + color"></h2>
          <h3 v-if="isHeader(3)" v-html="titleComputed" :class="'text-' + color"></h3>
          <h4 v-if="isHeader(4)" v-html="titleComputed" :class="'text-' + color"></h4>
          <div v-if="isHeader(5)" class="d-flex justify-content-between">
            <div class="d-flex">
              <i v-if="icon" :class="icon + ' fs-20 mt-1 mr-2 text-' + color"></i>
              <h5 v-html="titleComputed" :class="'text-' + color"></h5>
            </div>
          </div>
          <slot name="header-title"></slot>
        </div>
        <slot name="header-right"></slot>
      </div>
      <div :class="blocContentClass">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
